import i18n from '@/libs/i18n'
import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  getCurrentInstance,
  watch,
} from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import tagModel from '@/models/tag/tag-list'

export default function useTagList() {
  const vm = getCurrentInstance().proxy

  const { fetchTagList } = tagModel()

  const respData = reactive({
    payload: [],
  })

  const {
    openSuccessModal,
    openDefaultErrorModal,
    openWarningModal,
  } = useValidationModal()

  const fetchTagListData = () => {
    store
      .dispatch('api/apiRequest', fetchTagList)
      .then(resp => {
        if (resp.data.tag_list.length > 0) {
          respData.payload = resp.data.tag_list.map(obj => ({
            seq: obj.seq,
            label: obj.tag,
          }))
        }
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {})
    return respData //*** เวลาไปเรียกใช้ต้อง .payload ด้วย
  }

  return { fetchTagListData }
}
